export const locale = {
    lang: 'pt',
    data: {
      'NOMBREIDIOMAS': {
        'es': 'espanhol',
        'en': 'Inglês',
        'pt': 'Português',
        'zh1': 'Chinês tradicional',
        'zh2': 'Simplificado chinês',
        'tr': 'turco',
        'vi': 'vietnamita',
        'ja': 'japonês',
        'my': 'malaio',
        'ro': 'romena',
        'ru': 'russo',
        'fr': 'Francês',
        'de': 'Alemão',
        'it': 'Italiana',
        'nl': 'Holandês',
        'ms': 'Malaio',
        'hi': 'hindi',
        'id': 'indonésio',
        'ua': 'Ucraniano',
        'ge': 'Georgiano',
        'uz': 'Uzbeque',
        'az': 'Azeri',
        'kk': 'Cazaquistão',
        'hr': 'croata',
        'ar': 'árabe',
        'mk': 'Macedônio',
        'lv': 'Letão',
        'pr': 'Portuguese (Portugal)',
        'th': 'Thai',
      }
    }
};
